import { ICollectionComponentState } from '../state/ICollectionComponentState';

export const getCollectionComponentUniqueId = (
  state: ICollectionComponentState,
) => {
  return `${state.toolbar.container.environment.componentId}_${state.toolbar.collection.queryName}`;
};
